module.exports = __webpack_public_path__ + "img/3.f480a80a.png";